import * as React from 'react';
import { useLocalizedSanityNewsBondsByUrlIdWithoutInvalid } from '../../../../../../../../../../../../../../../../../../sanity';
import { useOuiStyleMediaContextByIndex } from '../../../../../../../../../../../../../../../../../MediaContext';
import { DesktopMapper, MobileMapper } from './components';

export const NewsBondsMapperContent = () => {
  const {
    data,
  } = useLocalizedSanityNewsBondsByUrlIdWithoutInvalid();
  const isUp = useOuiStyleMediaContextByIndex(3);
  if (data == null) {
    return null;
  }
  if (!isUp) {
    return (
      <MobileMapper />
    );
  }
  return (
    <DesktopMapper />
  );
};
